import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import api from "services/api";

import { AppCampaignSend } from "./AppCampaign.Send";
import { AppCampaignStatus } from "./AppCampaign.Status";
import { AppCampaignBeneficiaries } from "./AppCampaign.Beneficiaries";

import { Button, Container } from "./AppCampaign.styled";
import { IResponse, ICampaign } from "./AppCampaign.types";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export function AppCampaignView() {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as { workspaceId: string, templateId: string, workspaceActivityId: string; };
  const history = useHistory();

  const [currentStep, setCurrentStep] = useState<"SEND_CAMPAIGNS" | "CHECK_CAMPAIGNS">("SEND_CAMPAIGNS");
  const [selectedCampaign, setSelectedCampaign] = useState<ICampaign | null>(null);

  // Função para voltar da tela de detalhe
  function handleDetailBack() {
    setSelectedCampaign(null);
  }

  // Verifica se está na tela de detalhe
  const isDetailPage = selectedCampaign !== null;

  // Define título e ação do botão back baseado no estado
  const getPageTitle = () => {
    if (isDetailPage) {
      return `Campanha em andamento`;
    }
    return 'Campanhas';
  };

  const getBackAction = () => {
    if (isDetailPage) {
      return handleDetailBack;
    }
    return () => history.push(`/v2/workspaces/${workspaceId}/templates/${templateId}/data-governance`);
  };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["app_campaign", workspaceActivityId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/apps/campaign/${workspaceActivityId}`),
    select: (data) => data.data.data,
    refetchInterval: 5000,
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={getBackAction()}
            >
              <ArrowBack color="primary" />
            </IconButton>
            <Typography variant="h6">{getPageTitle()}</Typography>
          </div>
          
          {/* Só mostra as tabs se NÃO estiver na tela de detalhe */}
          {!isDetailPage && (
            <Container>
              <Button
                variant={currentStep === "SEND_CAMPAIGNS" ? "active" : "inactive"}
                onClick={() => setCurrentStep("SEND_CAMPAIGNS")}
              >
                Envio de campanha
              </Button>
              <Button
                variant={currentStep === "CHECK_CAMPAIGNS" ? "active" : "inactive"}
                onClick={() => setCurrentStep("CHECK_CAMPAIGNS")}
              >
                Campanha em andamento
              </Button>
            </Container>
          )}
          
          {/* Renderização condicional baseada no estado */}
          {!isDetailPage && currentStep === "SEND_CAMPAIGNS" && <AppCampaignSend beneficiaries={data.people} />}
          {!isDetailPage && currentStep === "CHECK_CAMPAIGNS" && (
            <AppCampaignStatus 
              campaigns={data.campaigns} 
              onCampaignSelect={setSelectedCampaign}
            />
          )}
          {isDetailPage && selectedCampaign && (
            <AppCampaignBeneficiaries campaign={selectedCampaign} />
          )}
        </>
      )}
    </>
  )
}
